import { Stack } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { Resources, useResource } from "Translations/Resources";
import type { FormEventHandler, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  onSubmit: FormEventHandler<HTMLFormElement>;
  isSubmitDisabled: boolean;
  isSaving: boolean;
  /** Overrides the default "Save" — e.g. a submit that doubles as a consent. */
  submitLabel?: string;
}>;

/**
 * Shared shell of the per-field edit dialogs on the public-information tab: the form
 * element, spacing and the Save button. Hosts own the fields, schema and save logic.
 */
export const FieldEditForm = ({
  onSubmit,
  isSubmitDisabled,
  isSaving,
  submitLabel,
  children,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack component="form" onSubmit={onSubmit} gap={3}>
      {children}
      <PrimaryButton
        fullWidth
        type="submit"
        disabled={isSubmitDisabled}
        isLoading={isSaving}
        variant="contained"
        color="primary"
      >
        {submitLabel ?? t(Resources.Common.Save)}
      </PrimaryButton>
    </Stack>
  );
};
